import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BulletList, BulletListItem, Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
export const GetPingHeaderTID = (parentTestId)=>getTestIds(parentTestId);
export const PingHeader = ()=>{
    const { t: pingTexts } = useLocaleKeys('integrations.setup.ping');
    const { t: sharedTexts } = useLocaleKeys('integrations.apps.shared');
    const { PingHeaderTestIds } = useMemo(()=>GetPingHeaderTID(), []);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 12,
        alignItems: "start",
        testId: PingHeaderTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                children: [
                    pingTexts.overviewDescription(),
                    ' ',
                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                        href: "https://help.sayanchor.com/en/articles/15293356-ping",
                        openInNewTab: true,
                        testId: PingHeaderTestIds.HelpCenterLink(),
                        bi: {
                            name: 'ping_help_center_link'
                        },
                        children: sharedTexts.readMore()
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                weight: "normal",
                children: pingTexts.whatYouCanDo()
            }),
            /*#__PURE__*/ _jsxs(BulletList, {
                spacing: "compact",
                children: [
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: pingTexts.capabilities.transcriptsToDocuments()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: pingTexts.capabilities.benchmarkPricing()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: pingTexts.capabilities.annualPriceIncreases()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: pingTexts.capabilities.clientNotifications()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: pingTexts.capabilities.billingAndReconciliation()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: pingTexts.capabilities.reduceAdminWork()
                    }),
                    /*#__PURE__*/ _jsx(BulletListItem, {
                        bulletSize: "small",
                        children: pingTexts.capabilities.revenueGrowth()
                    })
                ]
            })
        ]
    });
};
